module.exports = __webpack_public_path__ + "static/img/institutionImg.4363883a.png";